var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card",staticStyle:{"color":"grey"}},[_vm._v("  "),_c('h5',[_vm._v("Left Align")]),_c('Timeline',{attrs:{"value":_vm.events1},scopedSlots:_vm._u([{key:"content",fn:function(slotProps){return [_vm._v(" "+_vm._s(slotProps.item.status)+" ")]}}])})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }